import React from 'react';

const FlightOptionsContext = React.createContext(null);

export default FlightOptionsContext;
